import { configureStore } from '@reduxjs/toolkit';
import { authReducer } from '../Redux/Reducer/AuthReducer'
// import todoReducer from '../reducers/todoReducer'

export const store = configureStore({
  reducer: {
    user: authReducer.reducer,

  },
});